import authAtom from '~/recoil/atom/auth';
import cartTypeAtom from '~/recoil/atom/cartType';
import { useRecoilValue } from 'recoil';

import { useParams } from 'react-router-dom';

import { CartType } from '~/types/cart';
import { useMemo } from 'react';

export default function useCartId() {
  const auth = useRecoilValue(authAtom);

  const cartType = useRecoilValue(cartTypeAtom);
  const { groupId = '', enterpriseGroupBuyId = '' } = useParams();

  const cartId = useMemo(() => {
    if (!!enterpriseGroupBuyId) {
      return `enterprise_group_buy_${enterpriseGroupBuyId}_${auth?.uid || ''}`;
    }
    return cartType === CartType.CART_PERSONAL ? auth?.uid || '' : groupId;
  }, [cartType, enterpriseGroupBuyId, groupId, auth?.uid]);

  return { cartType, cartId };
}
